import { Subject } from 'rxjs';

const subject = new Subject();

export const showLoader = {
  sendMessage: (state: string) => subject.next(state),
  onMessage: () => subject.asObservable(),
};
